<template>
  <button
    :aria-label="`${isWished ? trans.get('miliboo.product.remove') : trans.get('miliboo.product.add')} ${trans.get('miliboo.product.the-product')} ${product.name} ${trans.get('miliboo.product.to-the-wishlist')}`"
    @click.capture="isFetching || isPending || toggle(product.id)"
  >
    <slot
      :wished="isWished"
      :is-loading="isFetching || isPending"
      :is-error="isError"
    />
  </button>
</template>
<script setup>
import { inject, ref, watch } from 'vue';
import useWishListCheckQuery from '../../composables/useWishListCheckQuery';
import useWishlistToggle from '../../features/myAccount/wishlist/composables/useWishlistToggle';

const props = defineProps({
  product: {
    type: Object,
    required: true,
  },
});

const trans = inject('translate');

const productIds = ref([props.product.id]);

const { data, isFetching, isError } = useWishListCheckQuery(productIds);

const isWished = ref(data?.data?.products.includes(props.product.id));

watch(data, (value) => value?.data?.products && (isWished.value = value?.data?.products.includes(props.product.id)));

const { toggle, isPending } = useWishlistToggle(isWished);

</script>
